import Vue from 'vue'
import store from './store';
import MyStudyChoiceHeartWidget from './components/MyStudyChoiceHeartWidget.vue';
import {getAttributeValue} from '@/shared/filters/utils-filter';
import VueCompositionAPI from "@vue/composition-api";

Vue.config.productionTip = false;
Vue.use(VueCompositionAPI)
let elements = document.querySelectorAll('my-studychoice-heart');

if (elements.length) {
    elements.forEach(element => {
        new Vue({
            el: element,
            store,
            render(h: any) {
                return h(MyStudyChoiceHeartWidget, {
                    props: {
                        config: {
                            study_code: getAttributeValue(element, 'study-code'),
                            language: getAttributeValue(element, 'language'),
                            labels: getAttributeValue(element, 'labels', true)
                        }
                    }
                });
            },
        });
    });
}
